import React, { useCallback, useMemo } from "react";
import {
  Row,
  Col,
  Input,
  Select,
  Collapse,
  Icon,
  DatePicker,
  Button,
} from "antd";
import { withTranslation } from "react-i18next";
import MultiSelectFilter from "./MultiSelectFilter";
import moment from "moment";

const { Panel } = Collapse;
const { Option } = Select;

const renderInputLabel = (type) => {
  const labels = {
    shipmentCode: "Código de envío",
    imei: "Nº de IMEI",
    numRefClient: "Código de referencia",
  };
  return labels[type] || "";
};

const isValueEmpty = (value) => !value.trim();
const areDateValuesEmpty = (startValue, endValue) => !startValue || !endValue;
const isSearchDisabled = (searchParameters, advancedSearchVisible) => {
  if (isValueEmpty(searchParameters.value) && !advancedSearchVisible) {
    return true;
  }
  if (
    advancedSearchVisible &&
    areDateValuesEmpty(searchParameters.startValue, searchParameters.endValue)
  ) {
    return true;
  }
  return false;
};

const isButtonDisabled = (disabled) => (disabled ? "disabled" : "search-btn");

// const disabledDate = (date, otherDate, isStart) => {
//   if (!date || !otherDate) {
//     return false;
//   }
//   return isStart
//     ? date.valueOf() > otherDate.valueOf()
//     : date.valueOf() <= otherDate.valueOf();
// };

function Search({
  searchParameters,
  advancedSearchVisible,
  handleSearchShipments,
  handleDateRangeChange,
  handleSearchInputChange,
  handleTypeChange,
  handleToggleAdvancedSearch,
  searchOptions,
  handleAdvancedInputChange,
  handleMultiSelectChange,
  hasCriteria,
  handleClearSearch,
}) {
  const searchDisabled = isSearchDisabled(
    searchParameters,
    advancedSearchVisible,
  );

  // const toOptions = (arr = []) => arr.map((v) => ({ key: v, value: v }));

  const toMoment = useCallback((v) => (v ? moment(v) : null), []);

  const startM = useMemo(
    () => toMoment(searchParameters.startValue),
    [searchParameters.startValue, toMoment],
  );
  const endM = useMemo(
    () => toMoment(searchParameters.endValue),
    [searchParameters.endValue, toMoment],
  );

  const disableStart = useCallback(
    (date) => !!endM && date.isAfter(endM, "day"),
    [endM],
  );
  const disableEnd = useCallback(
    (date) => !!startM && !date.isAfter(startM, "day"),
    [startM],
  );

  return (
    <div className="Busca">
      <Row>
        <h2>Buscador de Envíos</h2>
        <Collapse
          defaultActiveKey={["1"]}
          expandIcon={({ isActive }) => (
            <Icon type="caret-right" rotate={isActive ? 90 : 0} />
          )}
        >
          <Panel
            header="Buscador"
            key="1"
            extra={<Icon type="minus-circle" />}
            className="Busca"
          >
            <Row>
              <form onSubmit={handleSearchShipments}>
                <Row
                  className="search-grid-row"
                  gutter={{ xs: 16, sm: 24, md: 32, lg: 40, xl: 48 }}
                  type="flex"
                >
                  <Col xs={24} md={6}>
                    <label>Tipo de búsqueda</label>
                    <br />
                    <Select
                      value={searchParameters.type}
                      onChange={handleTypeChange}
                      style={{ width: "100%" }}
                    >
                      <Option value="shipmentCode">Envío</Option>
                      <Option value="imei">IMEI</Option>
                      <Option value="numRefClient">
                        Referencia del cliente / pedido
                      </Option>
                    </Select>
                  </Col>

                  <Col xs={24} md={12}>
                    <label>{renderInputLabel(searchParameters.type)}</label>
                    <br />
                    <Input
                      type="text"
                      value={searchParameters.value}
                      onChange={handleSearchInputChange}
                      style={{ width: "100%", textTransform: "uppercase" }}
                    />
                  </Col>

                  <Col
                    xs={24}
                    md={6}
                    className="search-actions"
                    style={{ display: "flex", gap: 10, alignItems: "flex-end" }}
                  >
                    <br />
                    <Button
                      htmlType="submit"
                      disabled={searchDisabled}
                      className={isButtonDisabled(searchDisabled)}
                    >
                      Buscar
                    </Button>
                    <Button
                      htmlType="button"
                      onClick={handleClearSearch}
                      disabled={!hasCriteria}
                      className={isButtonDisabled(searchDisabled)}
                    >
                      Limpiar
                    </Button>
                  </Col>
                </Row>
              </form>
            </Row>
            <div style={{ marginTop: "1em" }}>
              <span
                style={{ cursor: "pointer", color: "blue" }}
                onClick={handleToggleAdvancedSearch}
              >
                {advancedSearchVisible
                  ? "Ocultar búsqueda avanzada "
                  : "Mostrar búsqueda avanzada "}
                <Icon type={advancedSearchVisible ? "up" : "down"} />
              </span>
              {advancedSearchVisible && (
                <div className="dateRange">
                  <h5 style={{ fontSize: 14 }}>
                    Buscador fecha alta en plataforma
                  </h5>
                  <Row
                    className="search-grid-row"
                    gutter={{ xs: 16, sm: 24, md: 32, lg: 40, xl: 48 }}
                    type="flex"
                  >
                    <Col xs={12} md={3}>
                      <label>Desde</label>
                      <br />
                      <DatePicker
                        value={startM}
                        disabledDate={disableStart}
                        format="DD/MM/YYYY"
                        onChange={(value) =>
                          handleDateRangeChange(
                            "startValue",
                            value ? value.toISOString() : null,
                          )
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>

                    <Col xs={12} md={3}>
                      <label>Hasta</label>
                      <br />
                      <DatePicker
                        value={endM}
                        disabledDate={disableEnd}
                        format="DD/MM/YYYY"
                        onChange={(value) =>
                          handleDateRangeChange(
                            "endValue",
                            value ? value.toISOString() : null,
                          )
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>

                    {/* <Col xs={24} md={6}>
                      <MultiSelectFilter
                        label="Detallable"
                        field="clientNumber"
                        placeholder="detallable"
                        options={toOptions(clientNumbers)}
                        value={searchParameters.clientNumber || []}
                        onChange={handleMultiSelectChange}
                        loading={userProfilesLoading}
                      />
                    </Col>

                    <Col xs={24} md={6}>
                      <MultiSelectFilter
                        label="Etiquetador"
                        field="labellerCode"
                        placeholder="etiquetador"
                        options={toOptions(labellerCodes)}
                        value={searchParameters.labellerCode || []}
                        onChange={handleMultiSelectChange}
                        loading={userProfilesLoading}
                      />
                    </Col> */}
                    <Col xs={24} md={6}>
                      <label>Detallable</label>
                      <br />
                      <Input
                        type="text"
                        value={searchParameters.clientNumber}
                        onChange={(e) =>
                          handleAdvancedInputChange(
                            "clientNumber",
                            e.target.value.toUpperCase(),
                          )
                        }
                        style={{ width: "100%", textTransform: "uppercase" }}
                      />
                    </Col>

                    <Col xs={24} md={6}>
                      <label>Etiquetador</label>
                      <br />
                      <Input
                        type="text"
                        value={searchParameters.labellerCode}
                        onChange={(e) =>
                          handleAdvancedInputChange(
                            "labellerCode",
                            e.target.value.toUpperCase(),
                          )
                        }
                        style={{ width: "100%", textTransform: "uppercase" }}
                      />
                    </Col>
                  </Row>
                  <Row
                    gutter={{ xs: 16, sm: 24, md: 32, lg: 40, xl: 48 }}
                    type="flex"
                    style={{ marginTop: 20 }}
                  >
                    {/* <Col xs={24} md={6}>
                      <MultiSelectFilter
                        label="Tipo de caja"
                        field="boxType"
                        placeholder="Tipo de caja"
                        options={searchOptions?.data?.boxTypeList || []}
                        value={searchParameters.boxType}
                        onChange={handleMultiSelectChange}
                        loading={searchOptions.status === "loading"}
                      />
                    </Col> */}

                    {/* <Col xs={24} md={6}>
                      <MultiSelectFilter
                        label="Tipo de trazabilidad de temperatura"
                        field="temperatureTrazability"
                        placeholder="Tipo de trazabilidad"
                        options={searchOptions?.data?.tempTrazabilityList || []}
                        value={searchParameters.temperatureTrazability}
                        onChange={handleMultiSelectChange}
                        loading={searchOptions.status === "loading"}
                      />
                    </Col> */}

                    {/* <Col xs={24} md={6}>
                      <MultiSelectFilter
                        label="Rango de temperatura"
                        field="temperatureRange"
                        placeholder="Rango de temperatura"
                        options={searchOptions?.data?.tempRangeList || []}
                        value={searchParameters.temperatureRange}
                        onChange={handleMultiSelectChange}
                        loading={searchOptions.status === "loading"}
                      />
                    </Col> */}
                  </Row>
                </div>
              )}
            </div>
          </Panel>
        </Collapse>
      </Row>
    </div>
  );
}

export default withTranslation()(Search);
